module.exports = __webpack_public_path__ + "fonts/semibold.71f8a6f.woff2";